import { GDTApiErrors } from '@/types';
import {
  SuggestUsersChallengeResponse,
  SearchUserResponse,
  DateResultsResponse,
  ChallengeInitResponse,
  GenericStateResponse,
  ChallengeUserResponse,
  ProcessChallengeResponse,
} from '@/types/challenges';
import { axiosErrorHandler, TEXTS, URLs } from '@/utils';
import axiosGdt from '@/utils/axiosGdt';

export const getChallengesRecommended = axiosErrorHandler(async () => {
  const url = `${URLs.DESAFIOUNOAUNO.SUGERIR_USUARIOS}`;
  const response = await axiosGdt.get<SuggestUsersChallengeResponse>(url);

  return response.data;
}, TEXTS.defaultError);

export const challengeUser = axiosErrorHandler(async (userId: number) => {
  const url = `${URLs.DESAFIOUNOAUNO.DESAFIAR_USUARIO}&idUsuarioDesafiar=${userId}`;
  const response = await axiosGdt.get<ChallengeUserResponse | GDTApiErrors>(
    url
  );

  return response.data;
}, TEXTS.defaultError);

export const searchUser = axiosErrorHandler(async (query: string) => {
  const url = `${URLs.DESAFIOUNOAUNO.BUSCAR_USUARIOS}?text=${query}`;
  const response = await axiosGdt.get<SearchUserResponse>(url);

  return response.data;
}, TEXTS.defaultError);

export const dateResults = axiosErrorHandler(async (id: number) => {
  const url = `${URLs.DESAFIOUNOAUNO.RESULTADOS_FECHA}&idFecha=${id}`;
  const response = await axiosGdt.get<DateResultsResponse>(url);

  return response.data;
}, TEXTS.defaultError);

export const challengeInit = axiosErrorHandler(async () => {
  const url = `${URLs.DESAFIOUNOAUNO.INIT}`;
  const response = await axiosGdt.get<ChallengeInitResponse>(url);

  return response.data;
}, TEXTS.defaultError);

// Diego

export const getDesafioAceptarTodos = axiosErrorHandler(async () => {
  const url = `${URLs.DESAFIOUNOAUNO.ACEPTAR_TODOS}`;
  const response = await axiosGdt.get<GenericStateResponse | GDTApiErrors>(url);
  return response.data;
}, TEXTS.defaultError);

export const requestTratarDesafio = axiosErrorHandler(
  async (idDesafio: number, operacion: string) => {
    // operacion->Texto de tipo de operación ("aceptar", "rechazar").
    const params = new URLSearchParams({
      operacion,
      idDesafio: String(idDesafio),
    });
    const url = `${URLs.DESAFIOUNOAUNO.TRATAR_DESAFIO}&${params.toString()}`;
    const response = await axiosGdt.get<
      ProcessChallengeResponse | GDTApiErrors
    >(url);
    return response.data;
  },
  TEXTS.defaultError
);

export const requestCallangeEveryone = axiosErrorHandler(
  async (idFecha: number) => {
    const url = `${
      URLs.DESAFIOUNOAUNO.VOLVER_A_DESAFIAR_TODOS
    }?idFecha=${idFecha.toString()}`;
    const response = await axiosGdt.post<GDTApiErrors>(url);
    return response.data;
  },
  TEXTS.defaultError
);
